import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["UNSAFE_valueTooltip"],
  _excluded2 = ["UNSAFE_valueTooltip"],
  _excluded3 = ["UNSAFE_valueTooltip"],
  _excluded4 = ["UNSAFE_valueTooltip"];
import React from "react";
/* eslint-disable react/no-danger */
import { getDriverFixedApr, getDriverFixedAprWithAnnotation, getDriverMinCreditScore as getQuickFactMinCreditScore, getDriverVariableApr, getDriverVariableAprWithAnnotation } from '@nerdwallet/marketplace/drivers/education-loans';

/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */
var getQuickFactFixedAPR = function getQuickFactFixedAPR(offer) {
  var _getDriverFixedApr = getDriverFixedApr(offer),
    valueTooltip = _getDriverFixedApr.UNSAFE_valueTooltip,
    driver = _objectWithoutProperties(_getDriverFixedApr, _excluded);
  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (fixed_apr_annotation) to a react component.
 */
var getQuickFactFixedAPRWithAnnotation = function getQuickFactFixedAPRWithAnnotation(offer) {
  var _getDriverFixedAprWit = getDriverFixedAprWithAnnotation(offer),
    valueTooltip = _getDriverFixedAprWit.UNSAFE_valueTooltip,
    driver = _objectWithoutProperties(_getDriverFixedAprWit, _excluded2);
  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */
var getQuickFactVariableAPR = function getQuickFactVariableAPR(offer) {
  var _getDriverVariableApr = getDriverVariableApr(offer),
    valueTooltip = _getDriverVariableApr.UNSAFE_valueTooltip,
    driver = _objectWithoutProperties(_getDriverVariableApr, _excluded3);
  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Convert UNSAFE_valueTooltip (variable_apr_annotation) to a react component.
 */
var getQuickFactVariableAPRWithAnnotation = function getQuickFactVariableAPRWithAnnotation(offer) {
  var _getDriverVariableApr2 = getDriverVariableAprWithAnnotation(offer),
    valueTooltip = _getDriverVariableApr2.UNSAFE_valueTooltip,
    driver = _objectWithoutProperties(_getDriverVariableApr2, _excluded4);
  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};

/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/education-loans` directly.
 */
export { getQuickFactFixedAPR, getQuickFactFixedAPRWithAnnotation, getQuickFactMinCreditScore, getQuickFactVariableAPR, getQuickFactVariableAPRWithAnnotation };